import { SkeletonPage } from '@/components/ui/skeleton'
import { BookkeeperOverviewSkeleton } from './BookkeeperOverviewSkeleton'

/** The page at path while it loads, beside the shell's rail: shaped like it where its shape is known. */
export function ProductPageSkeleton({ path }: { path: string }) {
  const page = path.replace(/(.)\/+$/, '$1')
  if (page === '/bookkeeper') return <BookkeeperOverviewSkeleton />
  return <SkeletonPage />
}
